import React, { useMemo } from "react";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 15,
    fontWeight: 600,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: "#1f4a7c1c",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const dashboardData = [
  {
    id: null,
    applicationNo: "/BP/PF/2026-27/0010",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      createdTime: 1780469783610,
      lastModifiedTime: 1780469798451,
    },
    department: "DA",
    createdUserName: "NAMAN R SRIVASTAVA",
    createdTime: "03-06-2026",
    lastUserName: null,
    lastCreatedTime: "03-06-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: null,
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "/BP/PF/2026-27/0011",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      createdTime: 1780473805269,
      lastModifiedTime: 1780473811493,
    },
    department: "DA",
    createdUserName: "NAMAN R SRIVASTAVA",
    createdTime: "03-06-2026",
    lastUserName: null,
    lastCreatedTime: "03-06-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: null,
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "/BP/PF/2026-27/0012",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      createdTime: 1780474487216,
      lastModifiedTime: 1780474487216,
    },
    department: "DA",
    createdUserName: "NAMAN R SRIVASTAVA",
    createdTime: "03-06-2026",
    lastUserName: null,
    lastCreatedTime: "03-06-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: null,
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0007",
    applicationType: "Purchasable FAR",
    status: "Pending with (Suresh Kumar Pandey) (JE)",
    auditDetails: {
      createdBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      lastModifiedBy: "a996b3f3-9e5a-4e5d-82a8-ff39c768a768",
      createdTime: 1776679501165,
      lastModifiedTime: 1776679547238,
    },
    department: "DA",
    createdUserName: "NAMAN R SRIVASTAVA",
    createdTime: "20-04-2026",
    lastUserName: "Suresh Kumar Pandey",
    lastCreatedTime: "20-04-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "JE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0008",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "21085789-e841-4d29-9dc3-f44d8a761b0a",
      lastModifiedBy: "21085789-e841-4d29-9dc3-f44d8a761b0a",
      createdTime: 1777964841702,
      lastModifiedTime: 1777964841702,
    },
    department: "DA",
    createdUserName: "Ajay",
    createdTime: "05-05-2026",
    lastUserName: null,
    lastCreatedTime: "05-05-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0013",
    applicationType: "Purchasable FAR",
    status: "Pending with (Lakshman Singh) (JE)",
    auditDetails: {
      createdBy: "d905b5f9-a42b-4c38-a302-0f4a17881d6a",
      lastModifiedBy: "d905b5f9-a42b-4c38-a302-0f4a17881d6a",
      createdTime: 1783664869988,
      lastModifiedTime: 1783665005772,
    },
    department: "DA",
    createdUserName: "Yash",
    createdTime: "10-07-2026",
    lastUserName: "Lakshman Singh",
    lastCreatedTime: "10-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "JE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0014",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
      lastModifiedBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
      createdTime: 1784895608605,
      lastModifiedTime: 1784895608605,
    },
    department: "DA",
    createdUserName: "Raj Singh",
    createdTime: "24-07-2026",
    lastUserName: null,
    lastCreatedTime: "24-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0015",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
      lastModifiedBy: "29189958-924d-4682-b3c5-ccf7a0bf39e2",
      createdTime: 1784966021228,
      lastModifiedTime: 1784966021228,
    },
    department: "DA",
    createdUserName: "Raj Singh",
    createdTime: "25-07-2026",
    lastUserName: null,
    lastCreatedTime: "25-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0016",
    applicationType: "Purchasable FAR",
    status: "Pending with (Ravi Sharma) (AE)",
    auditDetails: {
      createdBy: "3f2d8e19-9c12-4a76-b123-2d5f6e8a9012",
      lastModifiedBy: "3f2d8e19-9c12-4a76-b123-2d5f6e8a9012",
      createdTime: 1785052100000,
      lastModifiedTime: 1785052150000,
    },
    department: "DA",
    createdUserName: "Amit Kumar",
    createdTime: "26-07-2026",
    lastUserName: "Ravi Sharma",
    lastCreatedTime: "26-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "AE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0017",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "4a2e7c11-8d34-4f52-a912-6c8e1b7d2304",
      lastModifiedBy: "4a2e7c11-8d34-4f52-a912-6c8e1b7d2304",
      createdTime: 1785138500000,
      lastModifiedTime: 1785138500000,
    },
    department: "DA",
    createdUserName: "Vikas Singh",
    createdTime: "27-07-2026",
    lastUserName: null,
    lastCreatedTime: "27-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: null,
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0018",
    applicationType: "Purchasable FAR",
    status: "Pending with (Anil Verma) (JE)",
    auditDetails: {
      createdBy: "5b3f9a22-7e45-4c61-b823-8d9f2e6a3415",
      lastModifiedBy: "5b3f9a22-7e45-4c61-b823-8d9f2e6a3415",
      createdTime: 1785224900000,
      lastModifiedTime: 1785224950000,
    },
    department: "DA",
    createdUserName: "Deepak Gupta",
    createdTime: "28-07-2026",
    lastUserName: "Anil Verma",
    lastCreatedTime: "28-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "JE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0019",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "6c4a1b33-9f56-4d72-c934-9e0f3b7a4526",
      lastModifiedBy: "6c4a1b33-9f56-4d72-c934-9e0f3b7a4526",
      createdTime: 1785311300000,
      lastModifiedTime: 1785311300000,
    },
    department: "DA",
    createdUserName: "Pankaj Yadav",
    createdTime: "29-07-2026",
    lastUserName: null,
    lastCreatedTime: "29-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0020",
    applicationType: "Purchasable FAR",
    status: "Pending with (Neeraj Singh) (JE)",
    auditDetails: {
      createdBy: "7d5b2c44-8a67-4e83-d145-0f1a4c8b5637",
      lastModifiedBy: "7d5b2c44-8a67-4e83-d145-0f1a4c8b5637",
      createdTime: 1785397700000,
      lastModifiedTime: 1785397750000,
    },
    department: "DA",
    createdUserName: "Rohit Mishra",
    createdTime: "30-07-2026",
    lastUserName: "Neeraj Singh",
    lastCreatedTime: "30-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "JE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Non Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0021",
    applicationType: "Purchasable FAR",
    status: "Document Uploaded",
    auditDetails: {
      createdBy: "8e6c3d55-9b78-4f94-e256-1a2b5d9c6748",
      lastModifiedBy: "8e6c3d55-9b78-4f94-e256-1a2b5d9c6748",
      createdTime: 1785484100000,
      lastModifiedTime: 1785484100000,
    },
    department: "DA",
    createdUserName: "Sanjay Kumar",
    createdTime: "31-07-2026",
    lastUserName: null,
    lastCreatedTime: "31-07-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: null,
    mainDashBoardStatus: "Pending With Applicant",
    subDashBoardStatus: "Pending with Applicant Due to Auto Scrutiny",
    isRecievedFile: "false",
    riskType: null,
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "no",
    schemeType: "Scheme",
  },
  {
    id: null,
    applicationNo: "LDA/BP/PF/2026-27/0022",
    applicationType: "Purchasable FAR",
    status: "Pending with (Manoj Tiwari) (AE)",
    auditDetails: {
      createdBy: "9f7d4e66-ac89-4fa5-f367-2b3c6e0d7859",
      lastModifiedBy: "9f7d4e66-ac89-4fa5-f367-2b3c6e0d7859",
      createdTime: 1785570500000,
      lastModifiedTime: 1785570550000,
    },
    department: "DA",
    createdUserName: "Arun Singh",
    createdTime: "01-08-2026",
    lastUserName: "Manoj Tiwari",
    lastCreatedTime: "01-08-2026",
    createdUserDesignation: "Architect",
    lastUserDesignation: "AE",
    mainDashBoardStatus: "In Progress With Officers",
    subDashBoardStatus: null,
    isRecievedFile: "true",
    riskType: "HIGH_NIVESH",
    location1: "Lucknow Development Authority",
    shortName: "LDA",
    businessService: "BPA_PURCHASEFAR_DA",
    employeName: null,
    employeRole: null,
    isGovernmentBuilding: "yes",
    schemeType: "Scheme",
  },
];

const LandUseApprovedSummary = () => {
  const fileTypeSummary = useMemo(() => {
    const counts = {
      "Government Buildings": 0,
      Scheme: 0,
      "Non-Scheme": 0,
    };

    dashboardData.forEach((item) => {
      if (String(item?.isGovernmentBuilding).toLowerCase() === "yes") {
        counts["Government Buildings"] += 1;
        return;
      }

      const schemeType = String(item?.schemeType || "")
        .trim()
        .toLowerCase();
      if (schemeType === "scheme") {
        counts.Scheme += 1;
      } else if (schemeType === "non scheme" || schemeType === "non-scheme") {
        counts["Non-Scheme"] += 1;
      }
    });

    return Object.entries(counts).map(([type, count]) => ({ type, count }));
  }, [dashboardData]);

  return (
    <Box sx={{ p: 2, minWidth: 400 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, color: "#444", fontWeight: 600 }}>
        Total Approved Files: <span style={{ color: "#1976d2", fontWeight: 700 }}>{dashboardData.length}</span>
      </Typography>

      <TableContainer component={Paper} sx={{ borderRadius: "8px", overflow: "hidden" }}>
        <Table aria-label="land-use-approved-summary-table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Type of Files</StyledTableCell>
              <StyledTableCell align="center">Files Count</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fileTypeSummary.map((row) => (
              <StyledTableRow key={row.type}>
                <StyledTableCell>{row.type}</StyledTableCell>
                <StyledTableCell align="center">
                  <Box
                    sx={{
                      display: "inline-block",
                      backgroundColor: "#1976d220",
                      color: "#1976d2",
                      fontWeight: 700,
                      borderRadius: "12px",
                      px: 1.5,
                      py: 0.25,
                      minWidth: 36,
                      textAlign: "center",
                    }}
                  >
                    {row.count}
                  </Box>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LandUseApprovedSummary;
